// extracted by mini-css-extract-plugin
module.exports = {"DbDatabaseOptionsColumn":"DbDatabaseOptionsColumn_cSSRc","DbDatabaseLabel":"DbDatabaseLabel_ZN3ul"};